import * as Yup from "yup";

export const AddMembersSchema = Yup.object({
  members: Yup.array().of(Yup.string()),
});

export type AddMembersType = Yup.TypeOf<typeof AddMembersSchema>;
